<template>
  <div class="form_add_page">
    <div class="top-container flex_between">
      <div class="flex_center" style="cursor: pointer" @click="back">
        <i class="el-icon-arrow-left" />
        <div class="split"></div>
        {{ $t("home.applyClaim") }}
      </div>
      <div>
        <el-button
          class="primary-btn"
          size="small"
          type="primary"
          @click="back"
          >{{ $t("operate.backList") }}</el-button
        >
      </div>
    </div>
    <div class="form_info">
      <el-form :inline="true" :model="addForm" :rules="rules" ref="form">
        <div class="form-container">
          <!-- 索赔节点 -->
          <el-form-item :label="$t('claimantKd.spjd')" prop="claimNode">
            <el-select
              @change="changeNode"
              v-model="addForm.claimNode"
              filterable clearable
            >
              <el-option :label="$t('claimantKd.kx')" value="1"> </el-option>
              <el-option :label="$t('claimantKd.zc')" value="2"> </el-option>
            </el-select>
          </el-form-item>
          <!-- 索赔类型 -->
          <el-form-item :label="$t('claimantKd.spType')" prop="claimType">
            <el-select v-model="addForm.claimType" filterable clearable>
              <el-option :label="$t('claimantKd.yssh')" value="1"> </el-option>
              <el-option :label="$t('claimantKd.hc')" value="2"> </el-option>
              <el-option :label="$t('claimantKd.zlwt')" value="3"> </el-option>
              <el-option :label="$t('claimantKd.ztbf')" value="4"> </el-option>
              <el-option :label="$t('claimantKd.qt')" value="5"> </el-option>
            </el-select>
          </el-form-item>
          <!-- 开箱日期 -->
          <el-form-item :label="$t('claimantKd.kxrq')" prop="openBoxDate">
            <el-date-picker
              type="date"
              value-format="yyyy-MM-dd"
              v-model="addForm.openBoxDate"
              :placeholder="$t('placeholder.select')"
              style="width: 250px"
            ></el-date-picker>
          </el-form-item>
          <!-- 销售订单号 -->
          <el-form-item
            :label="$t('claimantKd.xsddh')"
            prop="claimStatementNum"
          >
            <el-input
              v-model="addForm.claimStatementNum"
              :placeholder="$t('placeholder.enter')"
            ></el-input>
          </el-form-item>
          <!-- 零部件专业 -->
          <el-form-item
            :label="$t('climant.partMajor')"
            v-show="addForm.lbjzyList"
          >
            <el-select
              disabled
              multiple
              v-model="addForm.lbjzyList"
              placeholder=" "
              filterable clearable
            >
              <el-option :label="$t('climant.carBody')" value="1"> </el-option>
              <el-option :label="$t('climant.chassis')" value="2"> </el-option>
              <el-option :label="$t('climant.electricalAppliances')" value="3">
              </el-option>
              <el-option
                :label="$t('climant.interiorAndExteriorDecoration')"
                value="4"
              >
              </el-option>
              <el-option :label="$t('climant.newEnergy')" value="5">
              </el-option>
              <el-option :label="$t('climant.power')" value="6"> </el-option>
            </el-select>
          </el-form-item>
          <!-- VIN -->
          <el-form-item
            :label="$t('seek.vin')"
            prop="vin"
            v-show="addForm.claimNode == 2"
          >
            <el-select
              v-model="addForm.vin"
              @change="changeVin"
              remote
              reserve-keyword
              placeholder=""
              :remote-method="remoteMethod"
              :loading="loading"
              filterable clearable
            >
              <el-option
                v-for="item in options"
                :key="item.vin"
                :label="item.vin"
                :value="item.vin"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 国家 -->
          <el-form-item :label="$t('home.country')" prop="country">
            <el-input
              disabled
              v-model="person.country"
              :placeholder="$t('placeholder.enter')"
            ></el-input>
          </el-form-item>
          <!-- 客户账号 -->
          <el-form-item :label="$t('claimantKd.khzh')" prop="customerAccount">
            <el-input
              disabled
              v-model="person.customerAccount"
              :placeholder="$t('placeholder.enter')"
            ></el-input>
          </el-form-item>
          <!-- 客户索赔号 -->
          <el-form-item :label="$t('home.customerClaimNumber')">
            <el-input
              v-model="addForm.customerClaimNumber"
              :placeholder="$t('placeholder.enter')"
            ></el-input>
          </el-form-item>
        </div>
        <!-- 配件故障信息 -->
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            {{ $t("claimantKd.pjgzxx") }}
          </div>
        </div>
        <div class="form-container">
          <!-- 发生日期 -->
          <el-form-item
            class="err-nowarp"
            :label="$t('seek.happenDate')"
            prop="happenDate"
          >
            <el-date-picker
              type="date"
              value-format="yyyy-MM-dd"
              v-model="addForm.happenDate"
              :placeholder="$t('placeholder.select')"
              style="width: 250px"
              @change="getPreSetData"
            ></el-date-picker>
          </el-form-item>
          <!-- 故障现象 -->
          <div>
            <el-form-item :label="$t('climant.hitchAppearance')" prop="symptom">
              <el-input
                type="textarea"
                v-model="addForm.symptom"
                style="width: 680px"
                :placeholder="$t('placeholder.enter')"
                maxlength="1000"
                show-word-limit
              ></el-input>
            </el-form-item>
          </div>
          <!-- 故障初步原因 -->
          <div>
            <el-form-item
              :label="$t('climant.hitchReson')"
              prop="preliminaryCauseOfFailure"
            >
              <el-input
                type="textarea"
                v-model="addForm.preliminaryCauseOfFailure"
                style="width: 680px"
                :placeholder="$t('placeholder.enter')"
                maxlength="1000"
                show-word-limit
              ></el-input>
            </el-form-item>
          </div>
          <!-- 故障处理方案 -->
          <div>
            <el-form-item
              :label="$t('climant.hitchPlan')"
              prop="processingScenarios"
            >
              <el-input
                type="textarea"
                v-model="addForm.processingScenarios"
                style="width: 680px"
                :placeholder="$t('placeholder.enter')"
                maxlength="1000"
                show-word-limit
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <!-- 故障件信息 -->
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            {{ $t("climant.gzjxxl") }}
          </div>
        </div>
        <div class="table-container" style="padding: 0 18px 0 54px">
          <div class="table-btn" style="margin: 15px 0">
            <el-button
              :disabled="tableData.length >= 20"
              type="primary"
              class="primary-btn"
              size="small"
              @click="handleAddFault"
              >{{ $t("home.add") }}</el-button
            >
          </div>
          <el-table
            ref="tableRef"
            :data="tableData"
            stripe
            border
            highlight-current-row
          >
            <!-- 序号 -->
            <el-table-column
              type="index"
              :label="$t('cart.xh')"
              width="60"
              align="center"
              :render-header="$globalRenderHeader"
            >
            </el-table-column>
            <!-- 外包装箱号 -->
            <el-table-column
              prop="boxNumber"
              :label="$t('claimantKd.wbzxh')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <el-input size="mini" v-model="scope.row.boxNumber"></el-input>
              </template>
            </el-table-column>

            <!-- 故障件件号 -->
            <el-table-column
              prop="faultPartNumber"
              :label="$t('climant.faultNo')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <el-autocomplete
                  :disabled="
                    !(addForm.currency === 1 || addForm.currency === 0)
                  "
                  :class="scope.row.error ? 'is-error' : ''"
                  size="mini"
                  :ref="'autocomplete' + scope.$index"
                  v-model="scope.row.faultPartNumber"
                  :placeholder="$t('placeholder.enter')"
                  :fetch-suggestions="getFaultList"
                  @select="handleSelect($event, scope.$index)"
                  @keyup.enter.native="
                    handleInput('autocomplete' + scope.$index)
                  "
                  @blur="onBlurFault(scope.$index)"
                ></el-autocomplete>
              </template>
            </el-table-column>
            <!-- 故障件名称 -->
            <el-table-column
              prop="faultPartName"
              :label="$t('climant.faultName')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <el-input
                  :disabled="faultPartNameDisabled[scope.$index]"
                  size="mini"
                  v-model="scope.row.faultPartName"
                  @blur="
                    getFaultPartNameZh(scope.row.faultPartName, scope.$index)
                  "
                ></el-input>
              </template>
            </el-table-column>
            <!-- 故障件单价 -->
            <el-table-column
              prop="faultPartUnitPrice"
              :label="$t('climant.faultPrice')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <div class="table-number-input">
                  <el-input-number
                    :controls="false"
                    :precision="2"
                    size="mini"
                    :disabled="faultPartNameDisabled[scope.$index]"
                    v-model="scope.row.faultPartUnitPrice"
                    class="prepend-input"
                    @change="getTotalPrice('fault', scope.$index)"
                  ></el-input-number>
                  <div class="number-input-prepend">
                    {{ addForm.currency == 0 ? "￥" : "" }}
                    {{ addForm.currency == 1 ? "$" : "" }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <!-- 纸箱号 -->
            <el-table-column
              prop="cartonNumber"
              :label="$t('claimantKd.zxh')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <el-input
                  size="mini"
                  v-model="scope.row.cartonNumber"
                ></el-input>
              </template>
            </el-table-column>
            <!-- 更换数量 -->
            <el-table-column
              prop="changeQuantity"
              :label="$t('climant.changeNum')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <div class="table-number-input">
                  <el-input-number
                    :controls="false"
                    :precision="0"
                    v-model="scope.row.changeQuantity"
                    :placeholder="$t('placeholder.enter')"
                    @change="getTotalPrice('fault', scope.$index)"
                  ></el-input-number>
                </div>
              </template>
            </el-table-column>
            <!-- 维修方案 -->
            <el-table-column
              :label="$t('climant.wxfa')"
              prop="repairPlan"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <el-select
                filterable clearable
                  @change="changeScheme(scope)"
                  v-model="scope.row.repairPlan"
                >
                  <el-option :label="$t('climant.wx')" :value="0"> </el-option>
                  <el-option :label="$t('climant.gh')" :value="1"> </el-option>
                  <el-option :label="$t('claimantKd.bf')" :value="2">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <!-- 工时 -->
            <el-table-column
              prop="workingHours"
              :label="$t('climant.manHour')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <div class="table-number-input">
                  <el-input-number
                    :controls="false"
                    :min="0"
                    :max="999"
                    :precision="2"
                    size="mini"
                    @change="getTotalPrice('fault', scope.$index)"
                    v-model="scope.row.workingHours"
                  ></el-input-number>
                </div>
              </template>
            </el-table-column>
            <!-- 运费 -->
            <el-table-column
              prop="shippingFee"
              :label="$t('climant.transportationCost')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <div class="table-number-input">
                  <el-input-number
                    :controls="false"
                    :precision="2"
                    size="mini"
                    @change="getTotalPrice('fault', scope.$index)"
                    v-model="scope.row.shippingFee"
                    class="prepend-input"
                  ></el-input-number>
                  <div class="number-input-prepend">
                    {{ addForm.currency === 0 ? "￥" : "" }}
                    {{ addForm.currency === 1 ? "$" : "" }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <!-- 关税 -->
            <el-table-column
              prop="tariff"
              :label="$t('climant.customs')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <div class="table-number-input">
                  <el-input-number
                    :controls="false"
                    :precision="2"
                    size="mini"
                    @change="getTotalPrice('fault', scope.$index)"
                    v-model="scope.row.tariff"
                    class="prepend-input"
                  ></el-input-number>
                  <div class="number-input-prepend">
                    {{ addForm.currency === 0 ? "￥" : "" }}
                    {{ addForm.currency === 1 ? "$" : "" }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <!-- 其他费用 -->
            <el-table-column
              prop="otherExpenses"
              :label="$t('climant.otherCost')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <div class="table-number-input">
                  <el-input-number
                    :controls="false"
                    :precision="2"
                    size="mini"
                    @change="getTotalPrice('fault', scope.$index)"
                    v-model="scope.row.otherExpenses"
                    class="prepend-input"
                  ></el-input-number>
                  <div class="number-input-prepend">
                    {{ addForm.currency === 0 ? "￥" : "" }}
                    {{ addForm.currency === 1 ? "$" : "" }}
                  </div>
                </div>
              </template>
            </el-table-column>

            <!-- 管理费费率 -->
            <el-table-column
              prop="managementFeeRate"
              :label="$t('climant.manageRate')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <div class="table-number-input">
                  <el-input-number
                    disabled
                    :controls="false"
                    :precision="3"
                    size="mini"
                    v-model="scope.row.managementFeeRate"
                  ></el-input-number>
                </div>
              </template>
            </el-table-column>
            <!-- 工时费用 -->
            <el-table-column
              prop="laborCost"
              :label="$t('claimantKd.gsfy')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <div class="table-number-input">
                  <el-input-number
                    size="mini"
                    disabled
                    v-model="scope.row.laborCost"
                    :controls="false"
                    :precision="2"
                    class="prepend-input"
                  ></el-input-number>
                  <div class="number-input-prepend">
                    {{ addForm.currency == 0 ? "￥" : "" }}
                    {{ addForm.currency == 1 ? "$" : "" }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <!-- 材料费用 -->
            <el-table-column
              prop="materialCost"
              :label="$t('claimantKd.clfy')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <div class="table-number-input">
                  <el-input-number
                    size="mini"
                    disabled
                    v-model="scope.row.materialCost"
                    :controls="false"
                    :precision="2"
                    class="prepend-input"
                  ></el-input-number>
                  <div class="number-input-prepend">
                    {{ addForm.currency == 0 ? "￥" : "" }}
                    {{ addForm.currency == 1 ? "$" : "" }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <!-- 故障件总金额 -->
            <el-table-column
              prop="faultPartTotalPrice"
              :label="$t('climant.faultTotalPrice')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <div class="table-number-input">
                  <el-input-number
                    size="mini"
                    disabled
                    v-model="scope.row.faultPartTotalPrice"
                    :controls="false"
                    :precision="2"
                    class="prepend-input"
                  ></el-input-number>
                  <div class="number-input-prepend">
                    {{ addForm.currency == 0 ? "￥" : "" }}
                    {{ addForm.currency == 1 ? "$" : "" }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <!-- 操作 -->
            <el-table-column
              prop="id"
              :label="$t('cart.operate')"
              align="center"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="handleDeleteFault(scope.$index)"
                >
                  {{ $t("cart.delete") }}</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 费用信息 -->
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            {{ $t("climant.costInfo") }}
          </div>
        </div>
        <div class="form-container">
          <!-- 总工时 -->
          <el-form-item :label="$t('claimantKd.zgs') + '(h)'" prop="manHour">
            <el-input-number
              v-model="addForm.manHour"
              :controls="false"
              :min="0"
              :max="999"
              :precision="2"
              disabled
              :placeholder="$t('placeholder.enter')"
            ></el-input-number>
          </el-form-item>
          <!-- 工时单价 -->
          <el-form-item :label="$t('climant.hourlyPrice')" prop="hourlyRate">
            <el-input-number
              disabled
              v-model="addForm.hourlyRate"
              :controls="false"
              :precision="2"
              class="prepend-input"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ addForm.currency == 0 ? "￥" : "" }}
              {{ addForm.currency == 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 工时总费用 -->
          <el-form-item :label="$t('claimantKd.gszfy')" prop="totalCostOfWork">
            <el-input-number
              disabled
              v-model="addForm.totalCostOfWork"
              :controls="false"
              :precision="2"
              class="prepend-input"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ addForm.currency == 0 ? "￥" : "" }}
              {{ addForm.currency == 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 材料总费用 -->
          <el-form-item
            :label="$t('claimantKd.clzfy')"
            prop="materialTotalCost"
          >
            <el-input-number
              disabled
              v-model="addForm.materialTotalCost"
              :controls="false"
              :precision="2"
              class="prepend-input"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ addForm.currency == 0 ? "￥" : "" }}
              {{ addForm.currency == 1 ? "$" : "" }}
            </div>
          </el-form-item>

          <!-- 总运费 -->
          <el-form-item :label="$t('claimantKd.zyf')" prop="freight">
            <el-input-number
              v-model="addForm.freight"
              :controls="false"
              :precision="2"
              disabled
              class="prepend-input"
              :placeholder="$t('placeholder.enter')"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ addForm.currency == 0 ? "￥" : "" }}
              {{ addForm.currency == 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 总关税 -->
          <el-form-item :label="$t('claimantKd.zguanshui')" prop="tariff">
            <el-input-number
              v-model="addForm.tariff"
              :controls="false"
              :precision="2"
              disabled
              class="prepend-input"
              :placeholder="$t('placeholder.enter')"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ addForm.currency == 0 ? "￥" : "" }}
              {{ addForm.currency == 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 其他总费用 -->
          <el-form-item :label="$t('claimantKd.qtzfy')" prop="otherTotalCost">
            <el-input-number
              disabled
              v-model="addForm.otherTotalCost"
              :controls="false"
              :precision="2"
              class="prepend-input"
              :placeholder="$t('placeholder.enter')"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ addForm.currency == 0 ? "￥" : "" }}
              {{ addForm.currency == 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 结算币种 -->
          <el-form-item :label="$t('climant.currency')" prop="currency">
            <el-select v-model="addForm.currency" disabled>
              <el-option label="CNY" :value="0"> </el-option>
              <el-option label="USD" :value="1"> </el-option>
            </el-select>
          </el-form-item>
          <!-- 其他总费用说明 -->
          <el-form-item
            :label="$t('climant.otherCostCondition')"
            prop="otherInstruction"
          >
            <el-input
              v-model="addForm.otherExpenses"
              :placeholder="$t('placeholder.enter')"
            ></el-input>
          </el-form-item>
          <!-- 索赔总费用 -->
          <el-form-item
            :label="$t('climant.climantTotal')"
            prop="claimTotalCost"
          >
            <el-input-number
              disabled
              v-model="addForm.claimTotalCost"
              :controls="false"
              :precision="2"
              class="prepend-input"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ addForm.currency == 0 ? "￥" : "" }}
              {{ addForm.currency == 1 ? "$" : "" }}
            </div>
          </el-form-item>
        </div>
        <!-- 附件信息 -->
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            {{ $t("home.attachmentInfo") }}
          </div>
        </div>
        <div class="form-container">
          <fileUploadTips></fileUploadTips>
          <br />
          <el-form-item :label="$t('seek.appendix')" required>
            <div class="flex" v-for="(item, i) in tableData" :key="i">
              <span style="font-weight: bold"
                >{{ $t("zlfk.fj") }}{{ i + 1 }}：</span
              >
              <div class="flex">
                <drag-upload
                  ref="uploadFile"
                  :tipStatus="false"
                  :accessoryList.sync="item.fileList"
                  :httpRequest="action"
                />
                <!-- <el-upload
                  class="upload-demo"
                  :ref="'uploadFile' + i"
                  :headers="header"
                  :action="action"
                  :data="extraData"
                  :on-success="
                    (response, file, file_list) => {
                      return handleFileSuccess(response, file, file_list, i);
                    }
                  "
                  :before-upload="beforeFileUpload"
                  :on-remove="
                    (file, file_list) => {
                      return handleRemoveFile(file, file_list, i);
                    }
                  "
                  :on-change="
                    (response, file, file_list) => {
                      return handleChange(response, file, file_list, i);
                    }
                  "
                  multiple
                >
                  <el-button size="small" type="primary">{{
                    $t("seek.upload")
                  }}</el-button>
                </el-upload> -->

                <!-- <div>
                  <div
                    v-for="(file, index) in item.fileList"
                    :key="index"
                    class="file-list"
                  >
                    <div>
                      <i
                        class="el-icon-document"
                        style="margin-right: 7px; color: #909399"
                      ></i>
                      <span class="file-name">{{ file.fileName }}</span>
                    </div>
                    <div style="margin-left: 10px">
                      <el-button
                        type="text"
                        size="small"
                        style="color: red; padding: 0"
                        @click="handleRemoveFile(file, index, i)"
                        >{{ $t("cart.delete") }}</el-button
                      >
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
            <!-- <div
              v-for="file in fileListIng"
              :key="file.uid"
              class="file-list"
              style="border-bottom: 2px solid #409eff"
            >
              <div>
                <i
                  class="el-icon-document"
                  style="margin-right: 7px; color: #909399"
                ></i>
                <span class="file-name">{{ file.name }}</span>
              </div>
              <div class="file-name" style="margin-left: 10px; font-size: 12px">
                100%
              </div>
            </div> -->
          </el-form-item>
          <!-- <br /> -->
          <!-- <el-form-item>
            <div class="tips">
              <p>{{ $t("seek.formats") }}：</p>
              <p>1.{{ $t("seek.img") }}：jpg、png、jpeg、svg</p>
              <span>{{ $t("seek.limit10") }}</span>
              <p>2.{{ $t("seek.video") }}：mp4 、3gp、mov、m4v</p>
              <span>{{ $t("seek.limit100") }}</span>
              <p>3.{{ $t("seek.table") }}：xlsx</p>
              <span>{{ $t("seek.limit20") }}</span>
              <p>4.{{ $t("seek.doc") }}：doc、docx、pdf</p>
              <span>{{ $t("seek.limitDoc20") }}</span>
              <p>2.{{ $t("seek.zip") }}：zip 、rar、7z</p>
              <span>{{ $t("seek.limitZip100") }}</span>
              <p>{{ $t("seek.appendixTotal") }}</p>
            </div>
          </el-form-item> -->
        </div>
      </el-form>
    </div>
    <div class="flex_default_center">
      <el-button
        size="small"
        class="primary-btn"
        type="primary"
        :loading="saveLoading"
        @click="handleSaveAndCommit"
      >
        {{ $t("climant.saveCommit") }}
      </el-button>
      <el-button
        size="small"
        class="primary-btn"
        type="primary"
        :loading="saveLoading"
        @click="handleSave"
      >
        {{ $t("climant.save") }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { totalSum } from "@/util/totalSum";
import { uploadUrl } from "@/util/url";
import { deleteFile, getECPData, getECPDataByVIN } from "@/api/seek";
import { submitClaimant, getUserInfo, getPreset } from "@/api/kdsuopei";
import CryptoJS from "crypto-js";
import { getStorage, getSession } from "@/util/localStor";
import { getDictItem, getDictValue } from "@/util/dict";
import { translate } from "@/api/api";
import fileUploadTips from "@/components/fileUpload/fileUploadTips";
export default {
  data() {
    return {
      fileListIng: [],
      saveLoading: false, // 保存按钮点击状态
      faultList: [], // EPC系统故障件数据
      tableData: [], // 其他故障件
      faultError: false, // 主因故障件错误
      showfaultListError: false, // 其他故障件错误
      happenDateError: false, // 发生日期错误
      addForm: {}, // 表单数据
      upLoadFiles: [], // 上传文件
      uploading: false, // 上传状态
      header: {
        satoken: sessionStorage.getItem("satoken"),
      }, // 上传
      action:  "/customer/kdClaim/upload", // 上传
      fileList: [], // 上传
      newFileList: [],
      max: 500, // 上传
      sum: 0, // 上传
      exchangeRate: "1",
      loading: false,
      options: [],
      list: [],
      oldSum: null, //总价
      person: {}, //用户信息
      nationList: [], //国家列表,
      extraData: {
        fileSource: 19,
      },
      rulesList: {
        vin: [{ required: true, message: this.$t(" ") }],
        claimNode: [{ required: true, message: this.$t(" ") }],
        claimType: [{ required: true, message: this.$t(" ") }],
        openBoxDate: [{ required: true, message: this.$t(" ") }],
        claimStatementNum: [{ required: true, message: this.$t(" ") }],
        country: [{ required: true, message: this.$t(" ") }],
        customerAccount: [{ required: true, message: this.$t(" ") }],
        roadHaul: [{ required: true, message: this.$t(" ") }],
        productionDate: [{ required: true, message: this.$t(" ") }],
        happenDate: [
          { required: true, message: this.$t(" ") },
          { validator: this.validateHappenDate },
        ],
        symptom: [{ required: true, message: this.$t(" ") }],
        preliminaryCauseOfFailure: [{ required: true, message: this.$t(" ") }],
        processingScenarios: [{ required: true, message: this.$t(" ") }],
        managementFeeRate: [{ required: true, message: this.$t(" ") }],
        manHour: [{ required: true, message: this.$t(" ") }],
        hourlyRate: [{ required: true, message: this.$t(" ") }],
        totalCostOfWork: [{ required: true, message: this.$t(" ") }],
        materialTotalCost: [{ required: true, message: this.$t(" ") }],
        freight: [{ required: true, message: this.$t(" ") }],
        tariff: [{ required: true, message: this.$t(" ") }],
        // claimTotalCost: [
        //   { required: true, message: this.$t(" "), trigger: ["change", "blur"] },
        // ],
        currency: [{ required: true, message: this.$t(" ") }],
        fileList: [
          { required: true, message: "请上传附件", trigger: "change" },
        ],
      },
      faultPartNameDisabled: [],
    };
  },
  components: { fileUploadTips },
  watch: {
    // 语言切换时，清空表单验证
    "$i18n.locale": function (item) {
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
  },
  computed: {
    // 表单验证规则放在computed，防止语言切换时，验证提醒没有实时切换
    // 表单验证规则放在computed，防止语言切换时，验证提醒没有实时切换
    rules() {
      if (this.addForm.claimNode == 2) {
        return {
          ...this.rulesList,
          vin: [{ required: true, message: this.$t(" ") }],
        };
      } else {
        delete this.rulesList.vin;
        return { ...this.rulesList };
      }
    },
  },
  created() {},
  mounted() {
    this.addForm = getStorage("claimantData");
    this.oldSum = this.addForm.claimTotalCost
      ? this.addForm.claimTotalCost
      : null; //总价有值,保存下来
    this.tableData = this.addForm.kdClaimFaultyPartsEntityList || [];

    this.addForm.claimTotalCost = this.oldSum ? this.oldSum : undefined; //总价有值重新赋值，没值计算

    this.newFileList = [...this.fileList];

    this.getExchangeRate();
    this.getPersonData();
  },
  methods: {
    changeNode(val) {
      if (val == 2) {
        delete this.rulesList.vin;
      } else {
        this.rulesList = {
          ...this.rulesList,
          vin: [{ required: true, message: this.$t(" ") }],
        };
      }
    },
    // 获取客户信息
    async getPersonData() {
      const res = await getUserInfo();
      if (res.status == 0) {
        this.addForm.country = res.data.country;
        this.addForm.customerAccount = res.data.customerAccount;
        this.person = res.data;
        if (this.$i18n.locale !== "zh") {
          let nationList = Object.values(getSession("nationList"));
          nationList.map((item) => {
            if (item.id == res.data.customerCountry)
              this.person.country = item.enName;
          });
        }
      }
    },
    // 改变维修方案
    changeScheme(val) {
      this.getTotalPrice("fault", val.$index);
    },

    // 获取汇率
    async getExchangeRate() {
      const exchangeRateDict = await getDictItem("exchangeRate");
      const exchangeRateItem = getDictValue(exchangeRateDict, "USD/CNY");
      this.exchangeRate = exchangeRateItem?.codeText || this.exchangeRate;
    },
    // 返回
    back() {
      this.$router.go(-1);
    },
    // 根据发生日期获取预设数据
    async getPreSetData() {
      const res = await getPreset({
        data: { happenDate: this.addForm.happenDate },
      });
      if (res.data) {
        this.$set(
          this.addForm,
          "managementFeeRate",
          res.data.claimManagementRate
        );
        this.$set(this.addForm, "hourlyRate", res.data.claimUnitPrice);
        this.$set(this.addForm, "currency", res.data.currency);

        this.tableData?.map((item, index) => {
          this.tableData[index].managementFeeRate =
            this.addForm.managementFeeRate;
          if (
            (this.tableData[index].faultPartUnitPrice == 0 ||
              this.tableData[index].faultPartUnitPrice) &&
            (this.tableData[index].changeQuantity == 0 ||
              this.tableData[index].changeQuantity) &&
            (this.tableData[index].managementFeeRate == 0 ||
              this.tableData[index].managementFeeRate)
          ) {
            // 工时费
            this.tableData[index].laborCost = parseFloat(
              (
                this.tableData[index].workingHours *
                this.addForm.hourlyRate *
                this.tableData[index].changeQuantity
              ).toFixed(2)
            );
            // 材料费用 单价*数量*（1+管理费率）
            if (this.tableData[index].repairPlan == 0) {
              this.tableData[index].materialCost = 0;
            } else {
              this.tableData[index].materialCost = parseFloat(
                (
                  this.tableData[index].faultPartUnitPrice *
                  this.tableData[index].changeQuantity *
                  (1 + this.tableData[index].managementFeeRate)
                ).toFixed(2)
              );
            }

            // 总金额
            this.tableData[index].faultPartTotalPrice =
              this.tableData[index].laborCost +
              this.tableData[index].materialCost +
              this.tableData[index].shippingFee;
            this.tableData[index].tariff;
            this.tableData[index].otherExpenses;
          }
        });
        this.getTotalPrice("fault");
        this.happenDateError = false;
      } else {
        this.$set(this.addForm, "managementFeeRate", undefined);
        this.$set(this.addForm, "hourlyRate", undefined);
        this.$set(this.addForm, "currency", undefined);
        this.$set(this.addForm, "materialTotalCost", undefined);
        this.tableData?.map((item, index) => {
          this.tableData[index].managementFeeRate = undefined;
          this.tableData[index].faultPartTotalPrice = undefined;
          this.tableData[index].laborCost = undefined;
          this.tableData[index].materialCost = undefined;
        });
        this.happenDateError = true;
      }
      this.$refs.form.validateField("happenDate");
    },
    // 校验发生日期
    async validateHappenDate(rule, value, callback) {
      if (this.happenDateError) {
        callback(new Error(this.$t("climant.preSetError")));
      } else {
        callback();
      }
    },
    // 判断ECP数据中是否存在该故障件
    async findFault() {
      const faultIndex = this.faultList.findIndex((item) => {
        return item.code == this.addForm.faultPartNumber;
      });
      if (faultIndex == -1) {
        this.$set(this.addForm, "faultPartName", "");
        this.$set(this.addForm, "faultPartNameZh", "");
        this.$set(this.addForm, "faultPartUnitPrice", "");
        this.getTotalPrice("fault");
        this.faultError = true;
      } else {
        this.$set(
          this.addForm,
          "faultPartName",
          this.faultList[faultIndex][this.$i18n.locale] ||
            this.faultList[faultIndex].en ||
            this.faultList[faultIndex].zh
        );
        this.$set(
          this.addForm,
          "faultPartNameZh",
          this.faultList[faultIndex].zh
        );
        this.$set(
          this.addForm,
          "faultPartUnitPrice",
          this.addForm.currency == 0
            ? (this.faultList[faultIndex].price * this.exchangeRate).toFixed(2)
            : this.faultList[faultIndex].price
        );
        this.getTotalPrice("fault");
        this.faultError = false;
      }
    },
    // 校验故障件件号
    validateFaultPartNumber(rule, value, callback) {
      if (this.faultError) {
        callback(new Error(this.$t("climant.faultError")));
      } else {
        callback();
      }
    },
    // 获取ECP接口参数
    getECPParams() {
      const appId = "586738eb-49ed-4289-b951-193bfee3452b";
      const authToken = "298714f9-b43c-4772-b259-e6e2728cbd91";
      const now = new Date();
      const year = now.getFullYear();
      const month = (now.getMonth() + 1).toString().padStart(2, "0");
      const day = now.getDate().toString().padStart(2, "0");
      const hours = now.getHours().toString().padStart(2, "0");
      const minutes = now.getMinutes().toString().padStart(2, "0");
      const seconds = now.getSeconds().toString().padStart(2, "0");
      const timestamp =
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds;
      // 拼接appId、authToken和timestamp三个参数后，进行MD5摘要得到16进制摘要字符串，然后转大写得到签名
      const concat = appId + authToken + timestamp;
      const sign = CryptoJS.MD5(concat).toString().toUpperCase();
      return { appId, timestamp, sign };
    },
    // 根据故障件件号，EPC系统获取故障件
    async getFault(queryString) {
      const { appId, timestamp, sign } = this.getECPParams();
      const params = {
        appId,
        timestamp,
        sign,
        codeList: [queryString],
        account: getSession("person").customerAccountNum,
      };
      const res = await getECPData(params);
      const faultList = res.data;
      return faultList;
    },
    // 获取故障件列表
    async getFaultList(queryString, cb) {
      if (queryString && queryString.length >= 7) {
        const faultList = await this.getFault(queryString);
        this.faultList = [];
        faultList?.map((item) => {
          this.faultList.push({ ...item, zh: item.name, value: item.code });
        });
      } else {
        this.faultList = [];
      }
      cb(this.faultList);
    },
    // 输入故障件
    handleInput(ref) {
      this.$refs[ref].$refs.input.blur(); // 取消焦点
      this.$refs[ref].activated = false; // 关闭下拉框
    },
    // 表格输入故障件获取数据
    async onBlurFault(index) {
      this.$set(this.faultPartNameDisabled, index, true);
      if (this.faultList.length == 0) {
        const faultList = await this.getFault(
          this.tableData[index].faultPartNumber
        );
        this.faultList = [];
        faultList?.map((item) => {
          this.faultList.push({ ...item, zh: item.name, value: item.code });
        });
      }

      if (!this.tableData[index].faultPartNumber) {
        this.tableData[index].error = undefined;
      } else {
        const faultIndex = this.faultList.findIndex((item) => {
          return item.code == this.tableData[index].faultPartNumber;
        });
        if (faultIndex == -1) {
          this.tableData[index].faultPartName = "";
          this.tableData[index].faultPartNameZh = "";
          this.tableData[index].faultPartUnitPrice = "";
          this.$set(this.tableData[index], "error", true);
          this.getTotalPrice("fault", index);
          this.$set(this.faultPartNameDisabled, index, false);
        } else {
          this.tableData[index].faultPartName =
            this.faultList[faultIndex][this.$i18n.locale] ||
            this.faultList[faultIndex].en ||
            this.faultList[faultIndex].zh;
          this.tableData[index].faultPartNameZh = this.faultList[faultIndex].zh;
          this.tableData[index].faultPartUnitPrice =
            this.addForm.currency == 0
              ? (this.faultList[faultIndex].price * this.exchangeRate).toFixed(
                  2
                )
              : this.faultList[faultIndex].price;
          this.tableData[index].error = undefined;
          this.getTotalPrice("fault", index);
        }
      }
      this.showfaultListError =
        this.tableData.findIndex((item) => {
          return item.error == true;
        }) !== -1;
    },
    // 选择故障件
    handleSelect(item, index) {
      this.$set(this.faultPartNameDisabled, index, true);
      if (index == 0 || index) {
        this.tableData[index].faultPartName =
          item[this.$i18n.locale] || item.en || item.zh;
        this.tableData[index].faultPartNameZh = item.zh;
        this.tableData[index].faultPartUnitPrice =
          this.addForm.currency == 0
            ? (item.price * this.exchangeRate).toFixed(2)
            : item.price;
        this.tableData[index].error = undefined;
        this.getTotalPrice("fault", index);
        this.showfaultListError =
          this.tableData.findIndex((item) => {
            return item.error == true;
          }) !== -1;
      } else {
        this.$set(
          this.addForm,
          "faultPartName",
          item[this.$i18n.locale] || item.en || item.zh
        );
        this.$set(this.addForm, "faultPartNameZh", item.zh);
        this.$set(
          this.addForm,
          "faultPartUnitPrice",
          this.addForm.currency == 0
            ? (item.price * this.exchangeRate).toFixed(2)
            : item.price
        );
        this.getTotalPrice("fault");
        this.faultError = false;
      }
    },
    // 获取故障件中文名称
    async getFaultPartNameZh(faultPartName, index) {
      if (this.$i18n.locale === "zh") {
        this.tableData[index].faultPartNameZh = faultPartName;
        return;
      }
      try {
        let query = {
          data: {
            text: faultPartName,
            sourceLanguage: this.$i18n.locale,
            targetLanguage: "zh-CHS",
          },
        };
        const res = await translate(query);
        if (res.status == 0) {
          this.tableData[index].faultPartNameZh = res.data;
        } else {
          this.$DonMessage.warning("第三方接口反馈出错，请点击翻译按钮重试");
        }
      } catch (error) {}
    },
    // 获取故障件总金额
    /**
      计算逻辑：

    **/
    getTotalPrice(type, index) {
      if (type == "fault") {
        if (index == 0 || index) {
          // 工时费用（维修方案区分不同算法）
          if (
            (this.tableData[index].workingHours == 0 ||
              this.tableData[index].workingHours) &&
            (this.tableData[index].changeQuantity == 0 ||
              this.tableData[index].changeQuantity) &&
            (this.addForm.hourlyRate == 0 || this.addForm.hourlyRate)
          ) {
            // 工时*工时单价
            this.tableData[index].laborCost = parseFloat(
              (
                this.tableData[index].workingHours *
                this.addForm.hourlyRate *
                this.tableData[index].changeQuantity
              ).toFixed(2)
            );
          } else {
            this.tableData[index].laborCost = undefined;
          }

          // 材料费用 单价*数量*（1+管理费率）
          if (
            (this.tableData[index].faultPartUnitPrice == 0 ||
              this.tableData[index].faultPartUnitPrice) &&
            (this.tableData[index].changeQuantity == 0 ||
              this.tableData[index].changeQuantity) &&
            (this.tableData[index].managementFeeRate == 0 ||
              this.tableData[index].managementFeeRate)
          ) {
            if (this.tableData[index].repairPlan == 0) {
              this.tableData[index].materialCost = 0;
            } else {
              this.tableData[index].materialCost = parseFloat(
                (
                  this.tableData[index].faultPartUnitPrice *
                  this.tableData[index].changeQuantity *
                  (1 + this.tableData[index].managementFeeRate)
                ).toFixed(2)
              );
            }
          } else {
            this.tableData[index].materialCost = undefined;
          }
          // 单个故障件总金额
          if (
            (this.tableData[index].laborCost == 0 ||
              this.tableData[index].laborCost) &&
            (this.tableData[index].materialCost == 0 ||
              this.tableData[index].materialCost) &&
            (this.tableData[index].shippingFee == 0 ||
              this.tableData[index].shippingFee) &&
            (this.tableData[index].tariff == 0 || this.tableData[index].tariff)
            // &&
            // (this.tableData[index].otherExpenses == 0 ||
            //   this.tableData[index].otherExpenses)
          ) {
            this.tableData[index].faultPartTotalPrice =
              this.tableData[index].laborCost +
              this.tableData[index].materialCost +
              this.tableData[index].shippingFee +
              this.tableData[index].tariff +
              (this.tableData[index].otherExpenses || 0);
          } else {
            this.tableData[index].faultPartTotalPrice = undefined;
          }
        }

        if (this.tableData.length > 0) {
          let materialTotal = 0;
          let workingHoursTotal = 0;
          let laborCostTotal = 0;
          let freightTotal = 0;
          let tariffTotal = 0;
          let otherTotal = 0;
          let workingHourArr = [];
          this.tableData?.map((item) => {
            let newWorkingHours = item.workingHours * item.changeQuantity;
            workingHourArr.push(newWorkingHours);
            materialTotal += item.materialCost ? item.materialCost : 0; // 计算材料总费用

            laborCostTotal += item.laborCost ? item.laborCost : 0; // 计算工时总费用
            freightTotal += item.shippingFee ? item.shippingFee : 0; // 计算总运费
            tariffTotal += item.tariff ? item.tariff : 0; // 计算总关税
            otherTotal += item.otherExpenses ? item.otherExpenses : 0; // 计算其他总费用
          });
          workingHoursTotal = workingHourArr.reduce(
            (accumulator, currentValue) => accumulator + currentValue,
            0
          ); // 计算总工时
          this.$set(this.addForm, "materialTotalCost", materialTotal);
          this.$set(this.addForm, "manHour", workingHoursTotal);
          this.$set(this.addForm, "totalCostOfWork", laborCostTotal);
          this.$set(this.addForm, "freight", freightTotal);
          this.$set(this.addForm, "tariff", tariffTotal);
          this.$set(this.addForm, "otherTotalCost", otherTotal);
        } else {
          this.$set(this.addForm, "materialTotalCost", undefined);
          this.$set(this.addForm, "manHour", undefined);
          this.$set(this.addForm, "totalCostOfWork", undefined);
          this.$set(this.addForm, "freight", undefined);
          this.$set(this.addForm, "tariff", undefined);
          this.$set(this.addForm, "otherTotalCost", undefined);
        }

        // 计算索赔总费用
        if (
          (this.addForm.totalCostOfWork || this.addForm.totalCostOfWork == 0) &&
          (this.addForm.materialTotalCost ||
            this.addForm.materialTotalCost == 0) &&
          (this.addForm.freight || this.addForm.freight == 0) &&
          (this.addForm.tariff || this.addForm.tariff == 0)
        ) {
          this.$set(
            this.addForm,
            "claimTotalCost",
            this.addForm.totalCostOfWork +
              this.addForm.materialTotalCost +
              (this.addForm.otherTotalCost || 0) +
              this.addForm.freight +
              this.addForm.tariff
          );
        } else {
          this.$set(this.addForm, "claimTotalCost", undefined);
        }
      }
    },

    async remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        const { appId, timestamp, sign } = this.getECPParams();
        const params = {
          appId,
          timestamp,
          sign,
          vin: query,
          account: getSession("person").customerAccountNum,
        };
        const res = await getECPDataByVIN(params);
        if (res.data) {
          this.loading = false;
          this.options = res.data;
          this.options?.map((item, i) => {
            if (item.vin == query) {
              this.$set(this.addForm, "claimStatementNum", item.preOrder);
            }
          });
        } else {
          this.loading = false;
          this.options = [];
          this.addForm.vin = query;
          this.$set(this.addForm, "claimStatementNum", "");
        }
      } else {
        this.options = [];
        this.$set(this.addForm, "claimStatementNum", "");
      }
    },
    changeVin(val) {
      this.options?.map((item, i) => {
        if (item.vin == val) {
          this.$set(this.addForm, "claimStatementNum", item.preOrder);
        }
      });
    },
    // 新增其他故障件
    handleAddFault() {
      this.tableData.push({
        faultPartNumber: "", // 故障件件号
        changeQuantity: undefined, // 更换数量
        sourceOfComponents: "", // 零部件来源
        faultPartName: "", // 故障件名称
        faultPartNameZh: "", // 故障件名称中文
        faultPartUnitPrice: undefined, // 故障件单价
        managementFeeRate: this.addForm.managementFeeRate, // 管理费费率
        faultPartTotalPrice: undefined, // 故障件总金额
        boxNumber: "", // 外包装箱号
        cartonNumber: "", //纸箱号
        repairPlan: undefined, //维修方案
        otherExpenses: undefined, //其他费用
        laborCost: undefined, //工时费用
        materialCost: undefined, //材料费用
        workingHours: undefined, //工时
        shippingFee: undefined, //运费
        tariff: undefined, //关税
        fileList: [],
      });
    },
    // 删除其他故障件
    handleDeleteFault(index) {
      this.tableData.splice(index, 1);
      this.getTotalPrice("fault");
    },
    // 删除上传文件
    handleRemoveFile(file, fileList, index) {
      this.uploading = false;
      const uid = file.uploadFileId;
      // this.deleteUploadFile(file);
      this.fileList.forEach((pic, i) => {
        if (pic.uploadFileId == uid) {
          this.fileList.splice(i, 1);
        }
      });
      this.tableData[index].fileList.forEach((pic, i) => {
        if (pic.uploadFileId == uid) {
          this.tableData[index].fileList.splice(i, 1);
        }
      });
    },
    // 删除上传文件
    async deleteUploadFile(data) {
      const query = {
        data: {
          uploadFileId: data.uploadFileId,
          filePath: data.filePath,
        },
      };
      const res = await deleteFile(query);
    },
    // 上传
    handleChange(file, fileList) {
      this.upLoadFiles = fileList;
    },
    // 上传成功
    handleFileSuccess(res, file, file_list, i) {
      this.fileListIng.splice(
        this.fileListIng.findIndex((item) => {
          return item.uid === file.uid;
        }),
        1
      );
      if (res.status == 0) {
        const data = res.data;
        const obj = {
          uploadFileId: data.uploadFileId,
          // dataId: data.dataId,
          uploaderId: data.uploaderId,
          fileName: data.fileName,
          fileSize: data.fileSize,
          fileType: data.fileType,
          filePath: encodeURI(data.filePath),
          fileSource: data.fileSource,
          name: data.fileName,
          url: encodeURI(data.filePath),
        };
        this.tableData[i].fileList.push(obj);
        this.fileList.push(obj);
        const total = totalSum(this.fileList, "fileSize");
        this.sum = total / 1024;

        if (this.upLoadFiles.length == this.fileList.length) {
          this.uploading = false;
        }
      } else {
        this.$DonMessage.warning(res.message);
        const uid = file.uid; // 关键作用代码，去除文件列表失败文件
        const idx = this.$refs.uploadFile[i].uploadFiles.findIndex(
          (item) => item.uid == uid
        );
        this.$refs.uploadFile[i].uploadFiles.splice(idx, 1);
        if (this.upLoadFiles.length == this.fileList.length) {
          this.uploading = false;
        }
      }
    },
    // 上传之前
    beforeFileUpload(file) {
      this.fileListIng.push({
        uid: file.uid,
        name: file.name,
      });
      this.uploading = true;
      let lang = "";
      const language = sessionStorage.getItem("lang");
      language == "zh"
        ? (lang = 0)
        : language == "en"
        ? (lang = 1)
        : language == "ru"
        ? (lang = 2)
        : (lang = 3);
      this.header.lang = lang;
      let total = 0;
      total = this.sum + file.size / 1024 / 1024;

      if (total >= this.max) {
        this.$DonMessage.warning(this.$t("home.fileSum"));
        this.uploading = false;
        this.fileListIng.splice(
          this.fileListIng.findIndex((item) => {
            return item.uid === file.uid;
          }),
          1
        );
        return false;
      }
      const imgLt = 10;
      const videoLt = 100;
      const xlsLt = 20;
      const docLt = 20;
      const zipLt = 100;
      let limit = 0;
      let isLt = 0;
      // 图片
      const isJPG = file.type == "image/jpeg";
      const isPNG = file.type == "image/png";
      const isSvg = file.type == "image/svg+xml";
      let isImg = false;
      if (isJPG || isPNG || isSvg) {
        isImg = true;
      }
      if (isImg) {
        limit = imgLt;
        isLt = file.size / 1024 / 1024 < limit;
        if (!isLt) {
          this.uploading = false;
          this.$DonMessage.warning(this.$t("home.img10M"));
          this.fileListIng.splice(
            this.fileListIng.findIndex((item) => {
              return item.uid === file.uid;
            }),
            1
          );
        }
        return isImg && isLt;
      }

      // 视频
      const isMP4 = file.type == "video/mp4";
      const is3GP = file.type == "video/3gpp";
      const isMOV = file.type == "video/quicktime";
      const isM4V = file.type == "";
      let isVideo = false;
      if (isMP4 || is3GP || isMOV) {
        isVideo = true;
      }
      if (isVideo) {
        limit = videoLt;
        isLt = file.size / 1024 / 1024 < limit;
        if (!isLt) {
          this.$DonMessage.warning(this.$t("home.video100M"));
          this.uploading = false;
          this.fileListIng.splice(
            this.fileListIng.findIndex((item) => {
              return item.uid === file.uid;
            }),
            1
          );
        }
        return isVideo && isLt;
      }

      // 表格
      const isXLS =
        file.type ==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      if (isXLS) {
        limit = xlsLt;
        isLt = file.size / 1024 / 1024 < limit;
        if (!isLt) {
          this.$DonMessage.warning(this.$t("home.xlsx20M"));
          this.uploading = false;
          this.fileListIng.splice(
            this.fileListIng.findIndex((item) => {
              return item.uid === file.uid;
            }),
            1
          );
        }
        return isXLS && isLt;
      }

      // 文档
      const isDOC = file.type == "application/msword";
      const isDOCX =
        file.type ==
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      const isPDF = file.type == "application/pdf";
      let isFile = false;
      if (isDOC || isDOCX || isPDF) {
        isFile = true;
      }
      if (isFile) {
        limit = docLt;
        isLt = file.size / 1024 / 1024 < limit;
        if (!isLt) {
          this.$DonMessage.warning(this.$t("home.doc20M"));
          this.uploading = false;
          this.fileListIng.splice(
            this.fileListIng.findIndex((item) => {
              return item.uid === file.uid;
            }),
            1
          );
        }
        return isFile && isLt;
      }

      // 压缩包
      const isZIP =
        file.type === "application/zip" ||
        file.name.endsWith(".zip") ||
        file.name.endsWith(".rar") ||
        file.name.endsWith(".7z");
      if (isZIP) {
        limit = zipLt;
        isLt = file.size / 1024 / 1024 < limit;
        if (!isLt) {
          this.$DonMessage.warning(this.$t("home.zip100M"));
          this.uploading = false;
        }
        return isZIP && isLt;
      }
    },
    // 新增
    async add(status) {
      const submitData = JSON.parse(JSON.stringify(this.addForm));
      var canSubmit = true;
      submitData.kdClaimFaultyPartsEntityList = [];
      this.tableData?.map((item) => {
        if (item.faultPartNumber) {
          submitData.kdClaimFaultyPartsEntityList.push(item);
        }
        if (item.fileList && item.fileList.length == 0) {
          this.$DonMessage.warning(this.$t("claimantKd.fileTips"));
          canSubmit = false;
        }
      });
      submitData.status = status;
      submitData.languageType = this.$i18n.locale;
      if (canSubmit) {
        this.saveLoading = true;
        try {
          var res = {};
          res = await submitClaimant({ data: submitData });
          if (res.status == 0) {
            this.saveLoading = false;
            this.$DonMessage.success(this.$t("message.czcg"));
            this.back();
          } else {
            this.saveLoading = false;
            this.$DonMessage.warning(res.message);
          }
        } catch (error) {
          this.saveLoading = false;
        }
      }
    },
    // 保存并提交
    handleSaveAndCommit() {
      this.$refs.form.validate(async (valid) => {
        if (!this.getFileUploadTip()) {
          return;
        }
        if (valid) {
          this.add(1);
        } else {
          this.$DonMessage.warning(this.$t("claimantKd.submitTips"));
        }
      });
    },
    // 保存为草稿
    handleSave() {
      this.$refs.form.validate(async (valid) => {
        if (!this.getFileUploadTip()) {
          return;
        }
        if (valid) {
          this.add(0);
        } else {
          this.$DonMessage.warning(this.$t("claimantKd.submitTips"));
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.form_add_page {
  padding: 0 !important;
  // padding-bottom: 20px;
  // ::v-deep .el-input {
  //   width: 250px;
  // }
  // ::v-deep .el-table__body .el-input {
  //   width: unset;
  // }
  // ::v-deep .el-textarea__inner {
  //   font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
  //     "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  // }
  .top-container {
    padding: 10px 32px 10px 14px;
    border-bottom: 5px solid #efefef;
    .split {
      margin: 0 10px 0 7px;
      border: 1px solid #dde0e8;
      height: 18px;
    }
  }
  .hearder-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: #333333;
    padding: 14px 10px 14px 20px;
    border-bottom: 1px solid #dcdee0;
    .title-icon {
      margin-right: 10px;
    }
    .flex_between{
      display: flex !important;
    }
    p {
      font-size: 16px;
      color: #4095e5;
      font-weight: bold;
      i {
        font-size: 18px;
        color: #4095e5;
        display: inline-block;
        margin-right: 5px;
      }
    }
  }
  .form-container {
    margin-top: 34px;
    padding: 0 60px;
    .flex {
      margin-bottom: 5px;
      .fileUpload {
        width: 500px;
      }
    }
  }
  .second-title {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #bd3124;
    padding: 22px 10px 10px 62px;
    border-bottom: 1px solid #dcdee0;
  }
  .tips {
    line-height: 20px;
    color: #cecece;
    font-size: 14px;
    // p {
    //   font-size: 14px;
    //   line-height: 20px;
    // }
    // span {
    //   font-size: 12px;
    //   line-height: 16px;
    // }
  }
  .err-nowarp {
    ::v-deep .el-form-item__error {
      white-space: nowrap;
    }
  }
  .table-container {
    .is-error {
      ::v-deep .el-input__inner {
        border-color: #f56c6c;
      }
    }
  }
  .number-input {
    ::v-deep .el-input__inner {
      text-align: left;
    }
  }
  .number-input-prepend {
    // background-color: #f5f7fa;
    // color: #909399;
    // border-right: 1px solid #dcdfe6;
    // vertical-align: middle;
    // border-radius: 4px 0 0 4px;
    // display: inline-block;
    // height: 38px;
    // line-height: 38px;
    // width: 40px;
    // text-align: center;
    // position: absolute;
    // left: 1px;
    // top: 60%;
    // transform: translateY(-60%);
  }
  // .table-number-input-prepend {
  //   background-color: #f5f7fa;
  //   color: #909399;
  //   border-right: 1px solid #dcdfe6;
  //   vertical-align: middle;
  //   border-radius: 4px 0 0 4px;
  //   display: inline-block;
  //   height: 26px;
  //   line-height: 26px;
  //   width: 40px;
  //   text-align: center;
  //   position: absolute;
  //   left: 1px;
  //   top: 1px;
  // }
  .prepend-padding {
    ::v-deep .el-input__inner {
      // padding-left: 55px;
    }
  }
  .is-error {
    color: #f56c6c;
    font-size: 12px;
  }
  .file-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 26px;
    padding-left: 4px;
    margin-top: 5px;
    .file-name {
      color: #606266;
    }
  }
  ::v-deep .el-upload-list {
    // display: none;
  }
}
</style>
